import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    BaseRouteReuseStrategy,
} from '@angular/router';
import { caseIdPathParam } from '../constants/route-params';

/**
 * Custom route reuse strategy for case routes.
 *
 * Prevents Angular from reusing a route when the case ID changes,
 * ensuring that case-specific components are recreated and load data
 * for the newly selected case.
 *
 * All other routes use the default Angular route reuse behavior.
 */
@Injectable()
export class CaseRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(
        future: ActivatedRouteSnapshot,
        current: ActivatedRouteSnapshot
    ): boolean {
        const futureCaseId = future.paramMap.get(caseIdPathParam);
        const currentCaseId = current.paramMap.get(caseIdPathParam);

        if (
            futureCaseId != null &&
            currentCaseId != null &&
            futureCaseId !== currentCaseId
        ) {
            return false;
        }

        return super.shouldReuseRoute(future, current);
    }
}
